import { Button, Divider, Form, Input, Select, Switch, Tabs, DatePicker, Card, Tag, Row, Col, Descriptions } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import { ERegExp } from '../../enums/ERegExp';
import EUsersTypes from '../../enums/EUsersTypes';
import { displayMessage } from '../../helpers/messages';
import api from '../../services/api';
import { MaskedInput } from 'antd-mask-input';
import { cpfMask, cpfUnmask, phoneMask, phoneUnmask } from '../../helpers/iMask';
import dayjs from 'dayjs';

const DATE_FORMAT = 'DD/MM/YYYY';

// Labels dos campos (apenas os títulos, os valores vêm do backend)
const HEALTH_FIELD_LABELS = {
    food_intolerance: 'Intolerância Alimentar',
    water_intake: 'Água por Dia',
    daily_bowel_movement: 'Vai ao Banheiro Diariamente',
    sleep_quality: 'Qualidade do Sono',
    eats_vegetables_fruits: 'Come Vegetais e Frutas',
    drinks_soda_energy: 'Refrigerantes/Energéticos',
    uses_supplements: 'Uso de Suplementos',
    free_meals_per_week: 'Refeições Livres/Semana',
    training_time_minutes: 'Tempo para Treinar',
    body_pain: 'Dor no Corpo',
    cardio_time: 'Tempo de Cardio/Dia',
    target_muscle: 'Músculo que Quer Evoluir',
    practices_other_sports: 'Pratica Outros Esportes'
};

// Função para formatar valor do perfil de saúde (usa label do backend)
const formatHealthValue = (fieldData) => {
    if (!fieldData || fieldData.label === null || fieldData.label === undefined) {
        return <Tag color="default">Não informado</Tag>;
    }
    return fieldData.label;
};



const { Option } = Select
var userTypeList = Object.values(EUsersTypes)
    .filter(userType =>[EUsersTypes.EMPLOYEE.code, EUsersTypes.CLIENT_ADMIN.code].includes(userType.code))
    .map(userType => {
        return (
            { value: userType.code, label: userType.title }
        )
    })

export default function DetailUser() {
    const [form] = Form.useForm()
    const { idUser } = useParams()
    const [readOnly, setReadOnly] = useState(true)
    const [user, setUser] = useState(null)
    // const [clientsList, setClientsList] = useState(null)
    let hasChanged = false

    const {
        setShowLoading,
        mobile_mode,
        windowHeight,
        loadBadges,
        loggedUser
    } = useContext(GeneralContext)

    useEffect(() => {
        loadUserInfo(idUser)
    }, [])

    useEffect(() => {
        if (readOnly) {
            cpfMask('cpf-number')
            phoneMask('whatsapp-number')
        }
    }, [user])

    const loadUserInfo = async (id) => {
        try {
            let tempUser = await api.user.get(id)
            console.log(tempUser.data)
            // let tempClientList = await api.client.list()
            // setClientsList(tempClientList.data)
            
            // Formatar a data de expiração para o DatePicker
            const formData = {
                ...tempUser.data,
                plan_expired: tempUser.data.plan_expired ? dayjs(tempUser.data.plan_expired) : null
            }
            
            form.setFieldsValue(formData)
            setUser(tempUser.data)
        } catch (error) {
            alert(displayMessage('INVALID_USER'), 'warning')
        }
    }
    const onFinishEdit = async (values) => {
        if (readOnly) {
            setReadOnly(current => !current)
            return
        }

        setShowLoading(true)
        try {
            if (hasChanged) {
                let body = {
                    ...values,
                    id: user.id,
                    whatsapp: values.whatsapp ? phoneUnmask(values.whatsapp) : null,
                    cpf: values.cpf ? cpfUnmask(values.cpf) : null,
                    need_appointment: values.need_appointment,
                    free_appointment: values.free_appointment,
                    type: values.user_type,
                    user_type: values.user_type,
                    plan_expired: values?.plan_expired ? values.plan_expired.format('YYYY-MM-DD') : null,
                }
                await api.user.update(body)
                alert(displayMessage('USER_DATA_SAVED_SUCCESS'), 'success', displayMessage('SUCCESS'))
            }
        } finally {
            setReadOnly(current => !current)
            setShowLoading(false)
        }
    }

    const onCloseEdit = () => {
        setReadOnly(true)
        loadUserInfo(idUser)
    }

    const onOpenEdit = () => {
        readOnly ? setReadOnly(false) : form.submit()
    }

    const toggleActiveState = async () => {
        setShowLoading(true)

        try {
            if (!idUser) {
                alert(displayMessage('ERROR_UPDATE_USER_STATUS'), 'error', displayMessage('ERROR'))
                return
            }

            await api.user.changeActive(idUser)
            loadUserInfo(idUser)
        } catch (error) {
            alert(displayMessage('ERROR_UPDATE_USER_STATUS'), 'error', displayMessage('ERROR'))
        } finally {
            setShowLoading(false)
        }
    }

    async function onClickDoneConsulting() {
        setShowLoading(true)
        try {
            if (!idUser) {
                alert(displayMessage('USER_NOT_FOUND'), 'error', displayMessage('ERROR'))
                return
            }

            const { data } = await api.user.changeLastAppointment(idUser)

            form.setFieldsValue(data)
            setUser(data)
            loadBadges()
            loadUserInfo(idUser)
        } catch (error) {
            alert(displayMessage('ERROR_CHANGE_USER_INTEREST'), 'error', displayMessage('ERROR'))
        } finally {
            setShowLoading(false)
        }
    }

    const userIsActive = user?.is_active ? true : false

    return (
        <>
            <div className='font-bold text-lg text-appian-blue text-center' style={{ marginBottom: 10 }}>{displayMessage('DETAIL_USER')}</div>
            <div className='w-full flex-1'>
                <Tabs
                    defaultActiveKey="1"
                    className='h-full'
                    tabBarStyle={{
                        display: 'flex',
                        height: '50px'
                    }}
                    items={[
                        {
                            label: displayMessage('PERSONAL_DATA'),
                            key: '1',
                            children: (
                                <>
                                    <Form
                                        onFinish={onFinishEdit}
                                        layout="vertical"
                                        requiredMark='optional'
                                        form={form}
                                        onValuesChange={() => { hasChanged = true }}
                                    >
                                        <div style={{ maxWidth: '100%', flexDirection: 'column', gap: 10, display: 'flex' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: mobile_mode ? 'column' : 'row', gap: 8 }}>
                                                <Form.Item
                                                    label={<span className='text-fit-red-900 font-semibold' >{displayMessage('FIRST_NAME')}:</span>}
                                                    name="first_name"
                                                    className={`w-full m-[0]`}
                                                    style={{ flex: 1 }}
                                                    rules={[
                                                        { required: true, message: displayMessage('FIRST_NAME_MANDATORY') },
                                                        { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                                                        { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                                                    ]}
                                                >
                                                    <Input type="text" className='text-fit-red-900' disabled={readOnly} />
                                                </Form.Item>

                                                <Form.Item
                                                    label={<span className='text-fit-red-900 font-semibold' >{displayMessage('LAST_NAME')}:</span>}
                                                    name="last_name"
                                                    className={`w-full m-[0]`}
                                                    style={{ marginLeft: mobile_mode ? 0 : 5, flex: 1 }}
                                                    rules={[
                                                        { required: true, message: displayMessage('LAST_NAME_MANDATORY') },
                                                        { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                                                        { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                                                    ]}
                                                >
                                                    <Input type="text" className='text-fit-red-900' disabled={readOnly} />
                                                </Form.Item>
                                            </div>

                                            <Form.Item
                                                label={<span className='text-fit-red-900 font-semibold' > {displayMessage('EMAIL')}:</span>}
                                                name="email"
                                                className={`w-full m-0`}
                                                rules={[
                                                    { required: false },
                                                    { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                                                ]}
                                                style={{ flex: 1 }}

                                            >
                                                <Input type="email" className='text-fit-red-900' disabled={readOnly} />
                                            </Form.Item>
                                            <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 8 }}>
                                                <div style={{ display: 'flex', flex: 5, justifyContent: 'space-between', flexDirection: mobile_mode ? 'column' : 'row', gap: 8 }}>

                                                    <Form.Item
                                                        label={<span className='text-fit-red-900 font-semibold'>{displayMessage('CPF')}:</span>}
                                                        name="cpf"
                                                        className={`w-full m-0`}
                                                        style={{ flex: 1 }}
                                                    >
                                                        {readOnly ?
                                                            <Input type="text" className='text-fit-red-900' disabled id='cpf-number' />
                                                            :
                                                            <MaskedInput disabled mask='000.000.000-00' />
                                                        }
                                                    </Form.Item>

                                                    <Form.Item
                                                        label={<span className='text-fit-red-900 font-semibold'>{displayMessage('WHATSAPP')}:</span>}
                                                        name="whatsapp"
                                                        className={`w-full m-0`}
                                                        rules={[
                                                            { required: false },
                                                            { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') },
                                                        ]}
                                                        style={{ flex: 1 }}
                                                    >
                                                        {readOnly ?
                                                            <Input type="text" className='text-fit-red-900' disabled id='whatsapp-number' />
                                                            :
                                                            <MaskedInput mask='+00 (00) 00000-0000' />
                                                        }
                                                    </Form.Item>
                                                </div>
                                            </div>

                                            <div style={{ width: '100%', display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 10 }}>
                                                <Form.Item
                                                    label={<span className='text-fit-red-900 font-semibold'>{displayMessage('USER_TYPE')}:</span>}
                                                    name="user_type"
                                                    className={`w-full m-0`}
                                                    rules={[{ required: true, message: displayMessage('USER_TYPE_MANDATORY') }]}
                                                    style={{ flex: 1 }}
                                                >
                                                        <Select disabled={readOnly}>
                                                            {userTypeList.map(option => <Option key={option.value} value={option.value}>{option.label}</Option>)}
                                                        </Select>
                                                </Form.Item>

                                                <Form.Item
                                                    label={<span className='text-fit-red-900 font-semibold'>Validade do Plano:</span>}
                                                    name="plan_expired"
                                                    className={`w-full m-0`}
                                                    style={{ flex: 1 }}
                                                >
                                                    <DatePicker 
                                                        format={DATE_FORMAT}
                                                        placeholder="Sem limite"
                                                        style={{ width: '100%' }}
                                                        disabled={readOnly}
                                                        allowClear
                                                    />
                                                </Form.Item>
                                            </div>
                                            
                                            {user?.plan_expired && (
                                                <div style={{ 
                                                    marginTop: 10, 
                                                    padding: '8px 12px', 
                                                    borderRadius: 6,
                                                    backgroundColor: user?.is_plan_active ? '#f6ffed' : '#fff2f0',
                                                    border: `1px solid ${user?.is_plan_active ? '#b7eb8f' : '#ffccc7'}`
                                                }}>
                                                    <span style={{ 
                                                        color: user?.is_plan_active ? '#52c41a' : '#ff4d4f',
                                                        fontWeight: 500
                                                    }}>
                                                        {user?.is_plan_active 
                                                            ? `✓ Plano ativo${user?.days_until_expiration ? ` (${user.days_until_expiration} dias restantes)` : ''}`
                                                            : '✗ Plano expirado'
                                                        }
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </Form>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', flex: 1, flexDirection: mobile_mode ? 'column' : 'row' }}>
                                        <Button
                                            style={{ minWidth: 80, marginTop: 15, maxWidth: '30%' }}
                                            type={'primary'}
                                            onClick={() => toggleActiveState()}
                                            danger={!userIsActive}
                                        >
                                            {userIsActive ? displayMessage('IS_ACTIVE') : displayMessage('IS_INACTIVE')}
                                        </Button>

                                        <div style={{ display: 'flex', width: mobile_mode ? '100%' : 300, justifyContent: mobile_mode ? 'space-between' : 'flex-end', flexDirection: 'row', marginTop: mobile_mode ? 20 : 0 }}>
                                            <Button
                                                style={{ minWidth: 80, marginTop: 15, marginLeft: mobile_mode ? 0 : 10 }}
                                                type={'primary'}
                                                onClick={onOpenEdit}
                                            >
                                                {readOnly ? displayMessage('EDIT') : displayMessage('SAVE_EDIT')}
                                            </Button>
                                            {
                                                !readOnly ?
                                                    <Button
                                                        style={{ minWidth: 80, marginTop: 15, marginLeft: mobile_mode ? 0 : 10 }}
                                                        type={'primary'}
                                                        onClick={onCloseEdit}
                                                        danger

                                                    >
                                                        {displayMessage('CLOSE')}
                                                    </Button>
                                                    :
                                                    <div />
                                            }
                                        </div>
                                    </div>                          
                                </>
                            )
                        },
                        {
                            label: 'Perfil de Saúde',
                            key: '2',
                            style: { height: '100%' },
                            children: (
                                <div style={{ padding: '10px 0' }}>
                                    {user?.has_health_profile ? (
                                        <>
                                            {/* Dados Físicos */}
                                            <Card 
                                                title={<span style={{ color: '#C4161C' }}>📊 Dados Físicos</span>} 
                                                size="small" 
                                                style={{ marginBottom: 16 }}
                                            >
                                                <Row gutter={[16, 8]}>
                                                    <Col xs={24} sm={8}>
                                                        <div style={{ textAlign: 'center', padding: '10px', background: '#f5f5f5', borderRadius: 8 }}>
                                                            <div style={{ fontSize: 24, fontWeight: 'bold', color: '#C4161C' }}>
                                                                {user?.health_profile?.weight_kg || '-'} kg
                                                            </div>
                                                            <div style={{ color: '#666' }}>Peso</div>
                                                        </div>
                                                    </Col>
                                                    <Col xs={24} sm={8}>
                                                        <div style={{ textAlign: 'center', padding: '10px', background: '#f5f5f5', borderRadius: 8 }}>
                                                            <div style={{ fontSize: 24, fontWeight: 'bold', color: '#C4161C' }}>
                                                                {user?.health_profile?.height_cm || '-'} cm
                                                            </div>
                                                            <div style={{ color: '#666' }}>Altura</div>
                                                        </div>
                                                    </Col>
                                                    <Col xs={24} sm={8}>
                                                        <div style={{ textAlign: 'center', padding: '10px', background: '#f5f5f5', borderRadius: 8 }}>
                                                            <div style={{ fontSize: 24, fontWeight: 'bold', color: '#C4161C' }}>
                                                                {user?.health_profile?.age || '-'} anos
                                                            </div>
                                                            <div style={{ color: '#666' }}>Idade</div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card>

                                            {/* Hábitos Alimentares */}
                                            <Card 
                                                title={<span style={{ color: '#C4161C' }}>🥗 Hábitos Alimentares</span>} 
                                                size="small" 
                                                style={{ marginBottom: 16 }}
                                            >
                                                <Descriptions column={{ xs: 1, sm: 2, md: 2 }} size="small" bordered>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.food_intolerance}>
                                                        {formatHealthValue(user?.health_profile?.food_intolerance)}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.water_intake}>
                                                        {formatHealthValue(user?.health_profile?.water_intake)}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.daily_bowel_movement}>
                                                        {formatHealthValue(user?.health_profile?.daily_bowel_movement)}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.sleep_quality}>
                                                        {formatHealthValue(user?.health_profile?.sleep_quality)}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.eats_vegetables_fruits}>
                                                        {formatHealthValue(user?.health_profile?.eats_vegetables_fruits)}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.drinks_soda_energy}>
                                                        {formatHealthValue(user?.health_profile?.drinks_soda_energy)}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.uses_supplements}>
                                                        {formatHealthValue(user?.health_profile?.uses_supplements)}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.free_meals_per_week}>
                                                        {formatHealthValue(user?.health_profile?.free_meals_per_week)}
                                                    </Descriptions.Item>
                                                </Descriptions>
                                            </Card>

                                            {/* Treino */}
                                            <Card 
                                                title={<span style={{ color: '#C4161C' }}>💪 Treino</span>} 
                                                size="small"
                                            >
                                                <Descriptions column={{ xs: 1, sm: 2, md: 2 }} size="small" bordered>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.training_time_minutes}>
                                                        {formatHealthValue(user?.health_profile?.training_time_minutes)}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.body_pain}>
                                                        {formatHealthValue(user?.health_profile?.body_pain)}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.cardio_time}>
                                                        {formatHealthValue(user?.health_profile?.cardio_time)}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.target_muscle}>
                                                        {formatHealthValue(user?.health_profile?.target_muscle)}
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label={HEALTH_FIELD_LABELS.practices_other_sports}>
                                                        {formatHealthValue(user?.health_profile?.practices_other_sports)}
                                                    </Descriptions.Item>
                                                </Descriptions>
                                            </Card>
                                        </>
                                    ) : (
                                        <div style={{ 
                                            textAlign: 'center', 
                                            padding: '40px 20px',
                                            background: '#fafafa',
                                            borderRadius: 8,
                                            border: '1px dashed #d9d9d9'
                                        }}>
                                            <div style={{ fontSize: 48, marginBottom: 16 }}>📋</div>
                                            <div style={{ fontSize: 16, color: '#666', marginBottom: 8 }}>
                                                Este usuário ainda não preencheu o perfil de saúde
                                            </div>
                                            <div style={{ fontSize: 14, color: '#999' }}>
                                                O perfil será preenchido pelo usuário através do aplicativo
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        },
                        {
                            label: 'Preferências',
                            key: '3',
                            style: { height: '100%' },
                            children: (
                                <div style={{ padding: '10px 0' }}>
                                    <Row gutter={[16, 16]}>
                                        {/* Preferências de Dieta */}
                                        <Col xs={24} md={12}>
                                            <Card 
                                                title={<span style={{ color: '#C4161C' }}>🥗 Preferências de Dieta</span>} 
                                                size="small"
                                            >
                                                {user?.has_diet_preferences ? (
                                                    <Descriptions column={1} size="small" bordered>
                                                        <Descriptions.Item label="Gênero">
                                                            {user?.diet_preferences?.gender === 'male' ? 'Masculino' : 'Feminino'}
                                                        </Descriptions.Item>
                                                        <Descriptions.Item label="Objetivo">
                                                            {user?.diet_preferences?.type === 'weight_loss' ? 'Emagrecimento' : user?.diet_preferences?.type === 'muscle_gain' ? 'Ganho de Massa' : 'Manter meu peso'}
                                                        </Descriptions.Item>
                                                        <Descriptions.Item label="Refeições/Dia">
                                                            {user?.diet_preferences?.meals_per_day} refeições
                                                        </Descriptions.Item>
                                                    </Descriptions>
                                                ) : (
                                                    <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                                                        Não configurado
                                                    </div>
                                                )}
                                            </Card>
                                        </Col>

                                        {/* Preferências de Treino */}
                                        <Col xs={24} md={12}>
                                            <Card 
                                                title={<span style={{ color: '#C4161C' }}>🏋️ Preferências de Treino</span>} 
                                                size="small"
                                            >
                                                {user?.has_gym_preferences ? (
                                                    <Descriptions column={1} size="small" bordered>
                                                        <Descriptions.Item label="Gênero">
                                                            {user?.gym_preferences?.gender === 'male' ? 'Masculino' : 
                                                             user?.gym_preferences?.gender === 'female' ? 'Feminino' : 'Não especificado'}
                                                        </Descriptions.Item>
                                                        <Descriptions.Item label="Frequência Semanal">
                                                            {user?.gym_preferences?.weekly_frequency}x por semana
                                                        </Descriptions.Item>
                                                    </Descriptions>
                                                ) : (
                                                    <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                                                        Não configurado
                                                    </div>
                                                )}
                                            </Card>
                                        </Col>
                                    </Row>
                                </div>
                            )
                        }
                        // {
                        //     label: displayMessage('DIET_LIST'),
                        //     key: '4',
                        //     style: { height: '100%', },
                        //     children: (
                        //         <AttachmentsListDiet />
                        //     )
                        // },
                        // {
                        //     label: displayMessage('TRAINING_LIST'),
                        //     key: '5',
                        //     style: { height: '100%', },
                        //     children: (
                        //         <AttachmentsListTraining />
                        //     )
                        // }
                    ]}
                />
            </div>
        </>
    )
}